import React from 'react'
import AboutCounter from './AboutCounter'
import AboutFeatures from './AboutFeatures'
import AboutHistory from './AboutHistory'
import AboutExcellence from './AboutExcellence'
import AboutTeam from './AboutTeam'
import AboutMission from './AboutMission'
import AboutContent from './AboutContent'
import AboutService from './AboutService'
import AboutTimeline from './AboutTimeline'

export default function About() {

  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "/about",
        name: "About Us",
      }
    ]
  }

  const facilityData = {
    title: "",
    items: [
      {
        icon: "/assets/images/vision-img1.webp",
        heading: "Vision",
        description: "Deliver innovative laundry solutions ensuring efficiency, reliability, and long-term operational excellence."
      },
      {
        icon: "/assets/images/vision-img2.webp",
        heading: "Mission",
        description: "Provide advanced laundry systems with exceptional service & operational support worldwide."
      },
      {
        icon: "/assets/images/vision-img3.webp",
        heading: "Core Values",
        description: "Driven by integrity, innovation, quality, reliability, & continuous improvement across operations."
      },
    ]
  };


  return (
    <>
      <AboutContent data={bannerData} />
      <AboutService data={facilityData} />
      <AboutTimeline />
      {/* <AboutMission data={bannerData} /> */}
      <AboutCounter />
      {/* <AboutHistory /> */}
      <AboutTeam />
      <AboutFeatures />
      <AboutExcellence />

    </>
  )
}
